module.exports = __webpack_public_path__ + "img/web4.2e37c654.svg";